/**
 * SponsorenGrid — Firestore-Objekte, "logo" ist eine direkte Storage-URL.
 * Jeder Sponsor: { id, name, logo (URL, optional), url (optional) }
 */
export default function SponsorenGrid({ sponsoren }) {
  if (!sponsoren || sponsoren.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
      {sponsoren.map((s) => {
        const content = (
          <div className="flex items-center justify-center p-8 bg-white border border-black/5 shadow-sm hover:shadow-md hover:border-primary/20 transition-all h-36">
            {s.logo ? (
              <img
                src={s.logo}
                alt={s.name}
                loading="lazy"
                decoding="async"
                className="max-h-16 max-w-full object-contain grayscale hover:grayscale-0 transition-all"
              />
            ) : (
              <span className="text-xs font-bold text-dark/50 uppercase tracking-wide text-center">
                {s.name}
              </span>
            )}
          </div>
        );

        return s.url ? (
          <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" title={s.name}>
            {content}
          </a>
        ) : (
          <div key={s.id} title={s.name}>
            {content}
          </div>
        );
      })}
    </div>
  );
}
